<template>
  <div :class="d._class" :id="d._title">
    <div class="container">
      <h3>{{d._title}}</h3>
      <div>
        <dir v-show="d.isShowAcceptedPapers">
          <h4>Accepted Papers</h4>
          <ol>
            <li class="paragraph" v-for="(x, i) of d.acceptedPapers" :key="i">{{x}}</li>
          </ol>
        </dir>
        
        <table class="table table-bordered" style="margin:3em 0">
          <caption class="program-title" v-html="d.programTitle"></caption>
          <tbody>
            <tr class="active">
              <td width="110">Time Schedule</td>
              <td v-html="d.programDate"></td>
            </tr>
            <tr v-for="(x, i) of d.timelines" :key="i" :class="x._class">
              <td>{{x.time}}</td>
              <td>{{x.text}}</td>
            </tr>
          </tbody>
        </table>
        
        <!-- <p style="margin:3em 0">Conference Room: {{d.room}}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Program",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
        };
      }
    }
  },
  data() {
    return {
      d: {
        _class: "team",
        _title: "Program",

        talkTime: "TBD",
        article: {
          title: "TBD",
          abstract: "TBD"
        },
        author: {
          avatar: "TBD",
          name: "TBD",
          apartment: "TBD",
          company: "TBD",
          address: "TBD",
          brief: "TBD"
        },

        ...this.datum
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.program-title {
  font-size: 1.8em;
}
</style>



// WEBPACK FOOTER //
// src/components/Program.vue